if (!customElements.get('guide-decisions-slider')) {
  customElements.define(
    'guide-decisions-slider',
    class GuideDecisionsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.article-guide-decisions__cards');
        this.progress = this.querySelector('.article-guide-decisions__progress');
        if (!this.track || !this.progress) return;

        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.update);
        this.resizeObserver?.disconnect();
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        if (scrollWidth <= clientWidth) {
          this.progress.hidden = true;
          return;
        }
        this.progress.hidden = false;

        // Thumb width = visible share of the row; offset follows the scroll position
        const widthRatio = clientWidth / scrollWidth;
        const scrollRatio = scrollLeft / (scrollWidth - clientWidth);
        const offset = ((1 - widthRatio) / widthRatio) * scrollRatio * 100;
        this.progress.style.setProperty('--progress-width', `${widthRatio * 100}%`);
        this.progress.style.setProperty('--progress-offset', `${offset}%`);
      }
    }
  );
}
